// Unifica i referenti di un'anagrafica (cliente/partner/prospect):
// - `contatti`  → importati dal gestionale Fier (schema: titolo/nome/cognome/email/tel_cellulare/tel_fisso/ruoli/principale)
// - `referenti` → inseriti manualmente da CRM (schema: nome/ruolo/email/telefono)
// Restituisce una lista normalizzata { nome, ruolo, email, telefono, tel_cellulare, tel_fisso, principale, source }
// deduplicata per email (o nome+telefono).
export function mergeReferenti(doc) {
  if (!doc) return [];
  const out = [];
  const seen = new Set();
  const push = (r) => {
    const nome = (r.nome || "").trim();
    const email = (r.email || "").trim().toLowerCase();
    const tel = (r.telefono || r.tel_cellulare || r.tel_fisso || "").replace(/\s+/g, "");
    const key = email || `${nome.toLowerCase()}|${tel}`;
    if (!nome && !email && !tel) return;
    if (key && seen.has(key)) return;
    if (key) seen.add(key);
    out.push(r);
  };
  // Fier (contatti)
  for (const c of doc.contatti || []) {
    push({
      nome: [c.titolo, c.nome, c.cognome].filter(Boolean).join(" ").trim(),
      ruolo: c.ruoli || c.ruolo || "",
      email: c.email || "",
      telefono: c.tel_cellulare || c.tel_fisso || c.telefono || "",
      tel_cellulare: c.tel_cellulare || "",
      tel_fisso: c.tel_fisso || "",
      principale: !!c.principale,
      foto_url: (doc.contatti_foto || {})[(c.email || "").trim().toLowerCase() || [c.nome, c.cognome].filter(Boolean).join(" ").trim().toLowerCase()] || "",
      source: "fier",
    });
  }
  // CRM (referenti)
  for (const r of doc.referenti || []) {
    push({
      nome: (r.nome || "").trim(),
      ruolo: r.ruolo || "",
      email: r.email || "",
      telefono: r.telefono || "",
      tel_cellulare: r.telefono || "",
      tel_fisso: "",
      principale: !!r.principale,
      foto_url: r.foto_url || "",
      source: "crm",
    });
  }
  return out;
}
